import { Redirect as CoreRedirect } from '@reach/router';

CoreRedirect.prototype.constructor['defaultProps'] = { noThrow: true };

export default CoreRedirect;
